import { Container } from 'components/layout'
import React, { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { useFeatureFlags } from 'utils/featureFlags'

import AppManagementRouterRedirect from '../../AppManagementRouterRedirect'

const AppConnectSdkScene = React.lazy(() => import('./AppConnectSdkScene'))
const AppConnectHttpsScene = React.lazy(() => import('./AppConnectHttpsScene'))

type Props = {
  appId: string
}

/** Router for the Connect pages (SDK and HTTPS). */
export default function AppConnectRouter({ appId }: Props) {
  const { unifiedConnectionUrl } = useFeatureFlags()

  return (
    <Container narrow>
      <Suspense fallback={null}>
        <Routes>
          <Route path="sdk" element={<AppConnectSdkScene appId={appId} />} />
          {!unifiedConnectionUrl && (
            <Route
              path="https"
              element={<AppConnectHttpsScene appId={appId} />}
            />
          )}
          {/* Legacy redirect: API key creation moved to access/*. */}
          <Route
            path="api-keys/new"
            element={<AppManagementRouterRedirect area="access/api-keys/new" />}
          />
          <Route
            path="*"
            element={<AppManagementRouterRedirect area="connect/sdk" />}
          />
        </Routes>
      </Suspense>
    </Container>
  )
}
